import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAddForeCast_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAddForeCast_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetForecastWithId: any[];
  GetForecastWithId_dummy: any[];
  STDSelectAvailableForecastingProductForStation: any[];
  STDSelectAvailableForecastingProductForStation_dummy: any[];
  STDForecastSave: number;
  STDForecastSave_dummy: number;
  isComp195975Enabled: "enabled" | "disabled";
}

export class AddForeCast_ScreenBase extends React.PureComponent<
  IAddForeCast_ScreenProps,
  any
> {
  addforecast_195975_value_kuikaAutoCompleteRef: React.RefObject<any>;
  addforecast_466024_value_kuikaDateRef: React.RefObject<any>;
  addforecast_194042_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "e2cd5abd-7cd4-47c8-9d7b-83e5ae615c1c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 706978, PropertyName: "value", Value: "Öngörü Bilgileri" },
        { Id: 428074, PropertyName: "value", Value: "Ürün" },
        { Id: 195975, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 78431, PropertyName: "value", Value: "Öngörülen Adet" },
        { Id: 686404, PropertyName: "placeholder", Value: "15" },
        { Id: 564157, PropertyName: "value", Value: "Başlangıç Tarihi" },
        { Id: 466024, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 471492, PropertyName: "value", Value: "Bitiş Tarihi" },
        { Id: 194042, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 246119, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.addforecast_195975_value_kuikaAutoCompleteRef = React.createRef();
    this.addforecast_466024_value_kuikaDateRef = React.createRef();
    this.addforecast_194042_value_kuikaDateRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetForecastWithId: [],
      STDSelectAvailableForecastingProductForStation: [],
      STDForecastSave: 0,
      isComp195975Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("addforecast", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.AddForeCastPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("addforecast", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("addforecast", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AddForeCastPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      addforecast_195975_value:
        this.state.GetForecastWithId?.at?.(0)?.productId ?? undefined,
      addforecast_686404_value:
        this.state.GetForecastWithId?.at?.(0)?.expectedQuantity ?? undefined,
      addforecast_466024_value:
        this.state.GetForecastWithId?.at?.(0)?.startDate ?? undefined,
      addforecast_194042_value:
        this.state.GetForecastWithId?.at?.(0)?.endDate ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AddForeCastPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ForecastId ??
          this.props.screenInputs.forecastid,
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      SelectedProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetForecastWithId !== undefined
            ? stateVars.GetForecastWithId?.length > 0
              ? stateVars.GetForecastWithId[0].productId
              : null
            : this.state.GetForecastWithId?.length > 0
            ? this.state.GetForecastWithId[0].productId
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddForeCast/AddForeCastPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetForecastWithId = result?.data.getForecastWithId;
    formVars.addforecast_195975_value =
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].productId
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].productId
        : null;
    formVars.addforecast_195975_options =
      stateVars.STDSelectAvailableForecastingProductForStation;
    formVars.addforecast_686404_value = ReactSystemFunctions.value(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].expectedQuantity
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].expectedQuantity
        : null
    );
    formVars.addforecast_466024_value = ReactSystemFunctions.value(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].startDate
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].startDate
        : null
    );
    formVars.addforecast_194042_value = ReactSystemFunctions.value(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].endDate
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].endDate
        : null
    );
    stateVars.isComp195975Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetForecastWithId !== undefined
            ? stateVars.GetForecastWithId?.length > 0
              ? stateVars.GetForecastWithId[0].id
              : null
            : this.state.GetForecastWithId?.length > 0
            ? this.state.GetForecastWithId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.STDSelectAvailableForecastingProductForStation =
      result?.data.stdSelectAvailableForecastingProductForStation;

    formVars.addforecast_195975_value =
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].productId
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].productId
        : null;
    formVars.addforecast_195975_options =
      stateVars.STDSelectAvailableForecastingProductForStation;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AddForeCastPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddForeCastPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.addforecast_195975_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].productId
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].productId
        : null
    );

    stateVars.dataSource_195975 =
      stateVars.STDSelectAvailableForecastingProductForStation ??
      this.state.STDSelectAvailableForecastingProductForStation;
    stateVars.dataSource_195975 =
      stateVars.STDSelectAvailableForecastingProductForStation ??
      this.state.STDSelectAvailableForecastingProductForStation;
    stateVars.isComp195975Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetForecastWithId !== undefined
            ? stateVars.GetForecastWithId?.length > 0
              ? stateVars.GetForecastWithId[0].id
              : null
            : this.state.GetForecastWithId?.length > 0
            ? this.state.GetForecastWithId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.addforecast_686404_value = ReactSystemFunctions.value(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].expectedQuantity
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].expectedQuantity
        : null
    );

    formVars.addforecast_466024_value = ReactSystemFunctions.value(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].startDate
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].startDate
        : null
    );

    formVars.addforecast_194042_value = ReactSystemFunctions.value(
      this,
      stateVars.GetForecastWithId !== undefined
        ? stateVars.GetForecastWithId?.length > 0
          ? stateVars.GetForecastWithId[0].endDate
          : null
        : this.state.GetForecastWithId?.length > 0
        ? this.state.GetForecastWithId[0].endDate
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AddForeCastComponent_434833_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AddForeCastComponent_246119_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "addforecast_194042_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "addforecast_194042_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "addforecast_686404_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "addforecast_686404_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "addforecast_195975_value",
          "value",
          "STDSelectAvailableForecastingProductForStation",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "addforecast_195975_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "addforecast_466024_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "addforecast_466024_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "addforecast_194042_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "addforecast_686404_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "addforecast_195975_value",
            "value",
            "STDSelectAvailableForecastingProductForStation",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "addforecast_466024_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.StationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ForecastId ??
          this.props.screenInputs.forecastid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddForeCast/AddForeCastComponent_246119_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDForecastSave = result?.data.stdForecastSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AddForeCastComponent_246119_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddForeCastComponent_246119_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
